import { Link, useNavigate, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import SwiperCore, { Autoplay } from "swiper/core";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import CampaignIcon from "@mui/icons-material/Campaign";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import AnimatedPage from "../components/AnimatedPage";
import swal from "sweetalert";
import { useForm } from "react-hook-form";

function Home() {
    SwiperCore.use([Autoplay]);
    const swiperParams = {
        autoplay: { delay: 3000, disableOnInteraction: false }
    };

    const navigate = useNavigate();
    const location = useLocation();
    
    // Sử dụng useRef để lưu dấu vết Game đang chơi -> phục vụ việc tự động rút tiền
    const currentProductRef = useRef(null);
    const isPlayingRef = useRef(false);

    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [notify, setNotify] = useState(JSON.parse(localStorage.getItem("notify")));
    const [isLoading, setLoading] = useState(false);

    // ==========================================
    // STATE: TAB TRANG CHỦ & GAME CON
    // ==========================================
    const [activeTab, setActiveTab] = useState("HOME");

    // Lắng nghe lệnh mở Tab từ thanh Menu Sidebar (Header)
    useEffect(() => {
        if (location.state && location.state.activeTab) {
            setActiveTab(location.state.activeTab);
            window.history.replaceState({}, document.title);
        }
    }, [location.state]);

    // ==========================================
    // STATE: CHUYỂN QUỸ VÀ VÀO GAME
    // ==========================================
    const [playGame, setPlayGame] = useState(null);
    const [sanh, setSanh] = useState(null);
    const [product, setProduct] = useState(null);

    // ==========================================
    // STATE: DANH SÁCH GAME CON (SLOT, BẮN CÁ)
    // ==========================================
    const [gameList, setGameList] = useState([]);
    const [showGameListPopup, setShowGameListPopup] = useState(false);
    const [listTitle, setListTitle] = useState("");
    const [searchQuery, setSearchQuery] = useState("");

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) config.headers["Authorization"] = `Bearer ${token}`;
            return config;
        },
        (error) => Promise.reject(error)
    );

    // ==========================================
    // HÀM TỰ ĐỘNG RÚT TIỀN (BACKGROUND WITHDRAW)
    // ==========================================
    const performAutoWithdraw = async (prodType) => {
        if (!prodType) return;
        try {
            const resBal = await axios.post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { product_type: prodType });
            const currentBal = resBal.data?.data?.balance;
            if (currentBal >= 1) {
                await axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                    product_type: prodType,
                    type: 2,
                    money: Math.floor(currentBal)
                });
                console.log(`Đã tự động rút tiền từ sảnh ${prodType} thành công.`);
            }
        } catch (e) {
            console.log(`Tự động rút tiền sảnh ${prodType} thất bại.`, e);
        }
    };

    // FIX LỖI Ở ĐÂY: Ưu tiên đóng game ngay lập tức, việc rút tiền để nó chạy ngầm
    const handleForceExit = () => {
        // 1. Luôn ưu tiên tắt giao diện Game ngay lập tức
        setPlayGame(null);
        document.body.classList.remove("home-game-playing");

        // 2. Sau đó mới kiểm tra và chạy ngầm tiến trình rút tiền
        if (isPlayingRef.current && currentProductRef.current) {
            const prodToWithdraw = currentProductRef.current;
            isPlayingRef.current = false;
            currentProductRef.current = null;
            setProduct(null);
            
            performAutoWithdraw(prodToWithdraw); // Chạy ngầm
        }
    };

    // [BẮT SỰ KIỆN 1] KHI URL THAY ĐỔI / NGƯỜI DÙNG BẤM TAB KHÁC
    useEffect(() => {
        handleForceExit();
    }, [location.pathname, activeTab]); // Kể cả khi đổi Tab Trang chủ cũng rút tiền

    // [BẮT SỰ KIỆN 2] KHI ĐÓNG TAB, ĐÓNG TRÌNH DUYỆT, TẢI LẠI TRANG F5
    useEffect(() => {
        const handleTabClose = () => {
            if (isPlayingRef.current && currentProductRef.current) {
                const token = localStorage.getItem("user");
                if (token) {
                    const prod = currentProductRef.current;
                    fetch(`${process.env.REACT_APP_API_URL}/casino/getbalance`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                        body: JSON.stringify({ product_type: prod }),
                        keepalive: true
                    }).then(res => res.json()).then(data => {
                        const bal = data?.data?.balance;
                        if (bal >= 1) {
                            fetch(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                                body: JSON.stringify({ product_type: prod, type: 2, money: Math.floor(bal) }),
                                keepalive: true
                            }).catch(() => {});
                        }
                    }).catch(() => {});
                }
            }
        };
        window.addEventListener("beforeunload", handleTabClose);
        return () => window.removeEventListener("beforeunload", handleTabClose);
    }, []);

    // Cập nhật Profile liên tục 3s/lần
    const getProfile = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`).then((res) => {
            if (profile !== res.data.data) {
                setProfile(res.data.data);
                localStorage.setItem("profile", JSON.stringify(res.data.data));
            }
        }).catch(() => localStorage.removeItem("user"));
    };

    useEffect(() => {
        getProfile();
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getnotify`).then((res) => {
            setNotify(res.data.data);
            localStorage.setItem("notify", JSON.stringify(res.data.data));
        });

        const timer = setInterval(() => {
            getProfile();
        }, 3000);
        return () => clearInterval(timer);
    }, []);

    // Ẩn nội dung Body nếu Game đang mở để tránh Scroll lồng nhau
    useEffect(() => {
        if (playGame) {
            document.body.classList.add("home-game-playing");
        } else {
            document.body.classList.remove("home-game-playing");
        }
        return () => {
            document.body.classList.remove("home-game-playing");
        }
    }, [playGame]);

    function isMobileDevice() {
        if (window.innerWidth < 800) return true;
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    // MỞ POPUP GAME CON CỦA SLOTS / BẮN CÁ
    const fetchGameList = (title, product_type, game_type) => {
        setListTitle(title);
        setSearchQuery("");
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL}/casino/getgamelist`, { product_type, game_type })
            .then((res) => {
                if (res.data.data.length === 0) {
                    swal("Thông báo", "Sảnh game bảo trì", "error");
                    setLoading(false);
                } else {
                    setGameList(res.data.data[0]);
                    setShowGameListPopup(true);
                    setLoading(false);
                }
            })
            .catch(() => { swal("Thông báo", "Sảnh game bảo trì", "error"); setLoading(false); });
    };

    // ==========================================
    // LOGIC VÀO GAME & NẠP TIỀN TỰ ĐỘNG
    // ==========================================
    const launchGame = async (params) => {
        if (!localStorage.getItem("profile") || localStorage.getItem("profile") === "undefined") {
            navigate("/login"); return;
        }
        if (isLoading) return;

        handleForceExit(); // Rút tiền và Đóng game cũ nếu có đang mở
        setLoading(true);
        
        const form = { ...params, platform: isMobileDevice() ? "html5" : "html5-desktop" };
        
        try {
            const resGame = await axios.post(`${process.env.REACT_APP_API_URL}/casino/launchgame`, form);
            if (resGame.data.data.status !== 0) {
                setLoading(false);
                swal("Sảnh đang bảo trì", "Vui lòng chọn sảnh khác", "error");
                return;
            }

            const gameUrl = resGame.data.data.game_url;
            setProduct(params.product_type);
            currentProductRef.current = params.product_type; // Cập nhật Ref
            isPlayingRef.current = true; // Báo hiệu game đang bật
            setShowGameListPopup(false);

            // Nạp tự động nếu có số dư
            if (profile && profile.money >= 1000) {
                try {
                    await axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                        product_type: params.product_type,
                        type: 1, 
                        money: Math.floor(profile.money)
                    });
                } catch (transferErr) {
                    console.log("Lỗi nạp tự động:", transferErr);
                }
            }

            setPlayGame(gameUrl);
            setLoading(false);
            window.scrollTo({ top: 0, behavior: 'smooth' }); // Tự cuộn lên đầu

        } catch (err) {
            setLoading(false);
            if (err.response?.data?.data?.tokenVerificationData?.access === false) {
                swal("Lỗi", "Vui lòng đăng xuất và đăng nhập lại", "error"); return;
            }
            swal("Thất bại", err.response?.data?.message || "Đã có lỗi xảy ra", "error");
        }
    }

    function handleImageError(e, productCode, tcgGameCode) {
        e.target.onerror = null;
        e.target.src = `https://images.21947392.com/TCG_GAME_ICONS/${productCode}/${tcgGameCode}.png`;
    }

    // ==========================================
    // DỮ LIỆU MENU TRANG CHỦ
    // ==========================================
   const homeCategories = [
    { id: "SPORTS", title: "Thể Thao", img: "sport.png" },
    { id: "CASINO", title: "Sòng Bài", img: "casino.png" },
    { id: "SLOTS", title: "Nổ Hũ", img: "slot.png" },
    { id: "NUMBER", title: "TRÒ CHƠI", img: "number.png" },
    { id: "FISHING", title: "BẮN CÁ", img: "fishing.png" },
    { id: "LOTTERY", title: "Xổ Số", img: "lottery.png", link: "/xoso" }, // <-- Đã thêm link ở đây
    { id: "COCKFIGHT", title: "Đá Gà", img: "cockfight.png" },
    { id: "POKER", title: "Poker", img: "poker.png" },
];

    const subGames = {
        SPORTS: [
            { title: "AFB1188 THỂ THAO", imgUrl: "/newimg/sports_home_fbsports.png", pt: "142", gc: "FB0001", type: "DIRECT" },
            { title: "SABA THỂ THAO", imgUrl: "/newimg/sports_sabasport_home.png", pt: "174", gc: "SB0001", type: "DIRECT" },
            { title: "SBO THỂ THAO", imgUrl: "/newimg/sports_sportsbook_home.png", pt: "54", gc: "SBO041", type: "DIRECT" },
            { title: "CMD THỂ THAO", imgUrl: "/newimg/sports_home_cmd368.png", pt: "104", gc: "CMDCMD001", type: "DIRECT" },
            { title: "GGCS THỂ THAO", imgUrl: "/newimg/sports_sabasport_home.png", pt: "61", gc: "IMES17", type: "DIRECT" }
        ],
        CASINO: [
            { title: "WM CASINO", imgUrl: "/newimg/wm.png", pt: "118", gc: "WM0001", type: "DIRECT" },
            { title: "SEXY CASINO", imgUrl: "/newimg/s2.png", pt: "112", gc: "SEX001", type: "DIRECT" },
            { title: "DG CASINO", imgUrl: "/newimg/dg.png", pt: "27", gc: "DG0013", type: "DIRECT" },
            { title: "AG CASINO", imgUrl: "/newimg/ag.png", pt: "4", gc: "A00070", type: "DIRECT" },
            { title: "EVO CASINO", imgUrl: "/newimg/eg.png", pt: "86", gc: "EG0001", type: "DIRECT" },
            { title: "PT CASINO", imgUrl: "/newimg/pt.png", pt: "111", gc: "PTU002", type: "DIRECT" }
        ],
        SLOTS: [
            { title: "JILI SLOTS", imgUrl: require("../../images/games/jili.png"), pt: "140", gt: "RNG", type: "POPUP" },
            { title: "AG SLOTS", imgUrl: require("../../images/games/slotag.png"), pt: "4", gt: "RNG", type: "POPUP" },
            { title: "CQ9 SLOTS", imgUrl: require("../../images/games/cq9.png"), pt: "16", gt: "RNG", type: "POPUP" },
            { title: "BBIN SLOTS", imgUrl: require("../../images/games/bbin.png"), pt: "79", gt: "RNG", type: "POPUP" },
            { title: "PP SLOTS", imgUrl: require("../../images/games/pp.png"), pt: "39", gt: "RNG", type: "POPUP" },
            { title: "MG SLOTS", imgUrl: require("../../images/games/mg.png"), pt: "43", gt: "RNG", type: "POPUP" },
            { title: "JDB SLOTS", imgUrl: require("../../images/games/jdb.png"), pt: "55", gt: "RNG", type: "POPUP" },
            { title: "PT SLOTS", imgUrl: require("../../images/games/pt.png"), pt: "111", gt: "RNG", type: "POPUP" },
            { title: "PG SLOTS", imgUrl: require("../../images/games/pg.png"), pt: "98", gt: "RNG", type: "POPUP" }
        ],
        FISHING: [
            { title: "JILI BẮN CÁ", imgUrl: "/newimg/fish_jilifish_main.png", pt: "140", gt: "FISH", type: "POPUP" },
            { title: "JDB BẮN CÁ", imgUrl: "/newimg/fish_jdbfish_main.png", pt: "55", gt: "FISH", type: "POPUP" },
            { title: "CQ9 BẮN CÁ", imgUrl: "/newimg/fish_cq9fish_main.png", pt: "16", gc: "CQ0305", type: "DIRECT" },
            { title: "MG BẮN CÁ", imgUrl: "/newimg/fish_mgfish_main.png", pt: "43", gt: "FISH", type: "POPUP" },
        ],
        COCKFIGHT: [
            { title: "ĐÁ GÀ WS168", imgUrl: require("../../images/games/ws168.png"), pt: "202", gc: "WS1682", type: "DIRECT" },
            { title: "ĐÁ GÀ SV388", imgUrl: require("../../images/games/sv388.png"), pt: "132", gc: "SV3002", type: "DIRECT" }
        ],
        POKER: [
            { title: "V8 POKER", imgUrl: require("../../images/games/v8poker.png"), pt: "102", gc: "LCC001", type: "DIRECT" },
            { title: "KINGMAKER", imgUrl: require("../../images/games/kingmaker.png"), pt: "121", gc: "KM0001", type: "DIRECT" },
            { title: "KING POKER", imgUrl: require("../../images/games/kingpoker.png"), pt: "123", gc: "KP0001", type: "DIRECT" }
        ],
        LOTTERY: [
            { title: "XS MIỀN BẮC", imgUrl: require("../../images/mb75ss.png"), link: "/xs75s/lo2", type: "ROUTE" },
            { title: "XS MIỀN NAM", imgUrl: require("../../images/3mien/mienbac.png"), link: "/xsmb/lo2", type: "ROUTE" },
            { title: "XS MIỀN TRUNG", imgUrl: require("../../images/mb120ss.png"), link: "/xs120s/lo2", type: "ROUTE" }
        ],
        NUMBER: [
            { title: "TÀI XỈU 45S", imgUrl: require("../../images/tx45s.png"), link: "/tx45s", type: "ROUTE" },
            { title: "XÓC ĐĨA 45S", imgUrl: require("../../images/xocdia45s.png"), link: "/xd45s", type: "ROUTE" },
            { title: "TÀI XỈU 60S", imgUrl: require("../../images/tx60s.png"), link: "/tx60s", type: "ROUTE" },
            { title: "XÓC ĐĨA 60S", imgUrl: require("../../images/xocdia60s.png"), link: "/xd60s", type: "ROUTE" }
        ]
    };

    // XỬ LÝ CLICK VÀO TỪNG GAME CON TẠI TRANG CHỦ
    const handleGameAction = (game) => {
        if (game.type === "POPUP") {
            fetchGameList(game.title, game.pt, game.gt);
        } else if (game.type === "ROUTE") {
            navigate(game.link);
        } else {
            launchGame({ product_type: game.pt, game_code: game.gc });
        }
    };

    return (
        <AnimatedPage>
            {isLoading && (
                <div className="loading" style={{ zIndex: 99999999 }}>
                    <div className="loader"></div>
                </div>
            )}
            
            {/* TRUYỀN HÀM setActiveTab XUỐNG HEADER ĐỂ MENU HOẠT ĐỘNG */}
       {!playGame && <Header profile={profile} onSelectTab={setActiveTab} />}

            <style>{`
                html, body, #root {
                    height: auto !important;
                    overflow-y: auto !important;
                    background-color: #e3e1e2;
                }

                /* ẨN NỘI DUNG HOME KHI VÀO GAME ĐỂ TRÁNH LỖI CUỘN KÉP */
                body.home-game-playing .mobile-home-wrapper {
                    display: none !important;
                }
                body.home-game-playing footer {
                    display: none !important;
                }

                .mobile-home-wrapper {
                    background-color: #e3e1e2;
                    min-height: 100vh;
                    padding-bottom: 100px;
                    width: 100%;
                    overflow-x: hidden;
                }
                
                .auth-action-bar {
                    display: flex; width: 100%; box-shadow: 0 2px 5px rgba(0,0,0,0.1); margin-bottom: 10px;
                }
                .btn-login-bar {
                    flex: 1; background: #d93845; color: white; text-align: center; padding: 12px 0; font-weight: bold; text-decoration: none; font-size: 15px;
                }
                .btn-register-bar {
                    flex: 1; background: linear-gradient(to bottom, #fff59d, #fbc02d); color: #000; text-align: center; padding: 12px 0; font-weight: bold; text-decoration: none; font-size: 15px;
                }
                .btn-login-bar:hover, .btn-login-bar:active, .btn-login-bar:focus,
                .btn-register-bar:hover, .btn-register-bar:active, .btn-register-bar:focus {
                    text-decoration: none !important;
                    outline: none;
                }

                /* User Info Bar */
                .logend { background: #fff; border-bottom: 1px solid #e0e0e0; margin-bottom: 10px;}
                .logend-cont { display: flex; align-items: center; font-size: 13px; color: #333; }
                .logend-cont em { color: #d32f2f; font-weight: bold; font-style: normal; margin-left: 5px; }
                .mem_vip { margin-left: auto; margin-right: 15px; color: #ff9800; font-weight: bold; text-decoration: none; }
                .fr-wallet { display: flex; align-items: center; color: #d32f2f; font-weight: bold; text-decoration: none; }
                
                /* GIAO DIỆN TRANG CHỦ */
                .home-grid-container { padding: 0px 10px; display: grid; grid-template-columns: repeat(2, 1fr); gap: 5px; }
                .home-game-card { position: relative; border-radius: 8px; border: 2px solid #eac15a; overflow: hidden; box-shadow: 0 3px 6px rgba(0,0,0,0.15); cursor: pointer; background: #fff; transition: transform 0.2s; }
                .home-game-card:active { transform: scale(0.96); }
                .home-game-card img { width: 100%; height: auto; display: block; }
                .home-game-title { position: absolute; bottom: 0; left: 0; width: 100%; background: linear-gradient(to top, rgba(0,0,0,0.9), transparent); color: #fff; font-weight: 500; font-size: 13px; text-align: center; padding: 15px 0 6px 0; text-transform: uppercase; letter-spacing: 0.5px; }

                /* GIAO DIỆN GAME CON */
                .subgame-header { display: flex; align-items: center; padding: 10px 15px; background: #fff; margin-bottom: 10px; border-bottom: 2px solid #d32f2f; font-weight: bold; font-size: 15px; color: #d32f2f; cursor: pointer; box-shadow: 0 1px 3px rgba(0,0,0,0.1); }
                .subgame-header:active { background: #f0f0f0; }
                .subgame-grid-container { padding: 5px 10px; display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; }
                .subgame-card { background: #fff; border-radius: 4px; overflow: hidden; text-align: center; box-shadow: 0 1px 3px rgba(0,0,0,0.1); cursor: pointer; display: flex; flex-direction: column; }
                .subgame-card:active { transform: scale(0.96); }
                .subgame-img-wrap { height: 100px; padding: 0px; display: flex; justify-content: center; align-items: center; }
                .subgame-img-wrap img { max-width: 100%; max-height: 100%; object-fit: contain; }
                .subgame-title { background: #f8f8f8; color: #d32f2f; font-size: 11px; font-weight: bold; padding: 8px 2px; border-top: 1px solid #f0f0f0; text-transform: uppercase; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

                /* FOOTER LOGO */
                .footer-info-container { margin-top: 25px; }
                .home-footer-logo { text-align: center; padding: 20px 0; background: linear-gradient(90deg, #e3e1e2 0%, #e85d64 30%, #e85d64 70%, #e3e1e2 100%); }
                .home-footer-logo img { width: 140px; filter: drop-shadow(0px 2px 2px rgba(0,0,0,0.3)); }
                .footer-link-boxes { display: flex; justify-content: space-between; padding: 0 10px; gap: 5px; margin-top: 5px; }
                .footer-link-boxes a { flex: 1; background: #fff; color: #000; font-size: 12px; text-decoration: none; text-align: center; padding: 12px 2px; box-shadow: 0 1px 3px rgba(0,0,0,0.1); font-weight: 500; }

                /* POPUP CSS CHUNG (CHỈNH Z-INDEX CAO LÊN ĐỂ ĐÈ IFRAME GAME) */
                .global-popup-overlay { position: fixed !important; top: 0 !important; left: 0 !important; width: 100vw !important; height: 100vh !important; background: rgba(0, 0, 0, 0.75) !important; z-index: 99999999 !important; display: flex !important; align-items: center !important; justify-content: center !important; }
                .gamelist-popup { background: #1a1e29; border-radius: 12px; width: 95%; max-width: 600px; max-height: 85vh; display: flex; flex-direction: column; overflow: hidden; }
                .gamelist-popup-header { background: linear-gradient(135deg, #d32f2f, #b71c1c); color: #fff; padding: 15px 20px; font-weight: bold; font-size: 16px; display: flex; justify-content: space-between; align-items: center; }
                .gamelist-popup-body { padding: 15px; overflow-y: auto; flex-grow: 1; }
                .gl-search-box input { width: 100%; padding: 12px 15px; border-radius: 20px; border: none; background: #2b3245; color: #fff; outline: none; margin-bottom: 15px; box-sizing: border-box; }
                .new-grid-3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; }
                .new-gameslot-item { background: #2b3245; border-radius: 8px; overflow: hidden; cursor: pointer; text-align: center; border: 1px solid #3c455c; }
                .new-gameslot-item img { width: 100%; aspect-ratio: 1/1; object-fit: cover; }
                .new-gameslot-name { color: #fff; padding: 8px 4px; font-size: 11px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

                /* IFRAME GAME HIỂN THỊ TRONG TRANG */
                .embedded-game-view {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: #000;
    display: flex;
    flex-direction: column;
    z-index: 999999; /* Z-index cao nhất để đè lên mọi element khác trên trang */
}
                .game-top-bar {
                    height: 45px;
                    background: #1a1a1a;
                    padding: 0 15px;
                    display: flex;
                    align-items: center;
                    border-bottom: 1px solid #333;
                }
                .btn-exit-auto {
                    background: #d32f2f;
                    color: #fff;
                    border: none;
                    padding: 8px 15px;
                    border-radius: 4px;
                    cursor: pointer;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    gap: 5px;
                }
                .iframe-wrapper { width: 100%; flex: 1; border: none; background: #000; }
            `}</style>

            {/* IFRAME HIỂN THỊ GAME */}
            {playGame && (
                <div className="embedded-game-view">
                    <div className="game-top-bar">
                        <button className="btn-exit-auto" onClick={handleForceExit}>
                         Thoát 
                        </button>
                    </div>
                    <iframe src={playGame} className="iframe-wrapper" title="Game" />
                </div>
            )}

            {/* GIAO DIỆN TRANG CHỦ HOẶC SẢNH CON MỚI HIỂN THỊ KHI KHÔNG VÀO GAME */}
            {!playGame && (
                <div className="mobile-home-wrapper">
                    
                    <div className="box-slide">
                        {/* THÔNG BÁO MARQUEE */}
                        {notify && notify.length > 0 && notify[0]?.isShow === true && notify[0]?.title === "marquee" && (
                            <div className="marquees" style={{ display: 'flex', alignItems: 'center', background: '#fff', padding: '6px 10px', borderBottom: '1px solid #ddd' }}>
                                <CampaignIcon sx={{ fontSize: "20px", color: "#d32f2f", marginRight: "10px" }} />
                                <marquee direction="left" scrollamount="5" style={{ flex: 1, color: "#333", fontSize: "13px" }}>
                                    <span dangerouslySetInnerHTML={{ __html: notify[0].content }} />
                                </marquee>
                            </div>
                        )}
                        
                        {notify && notify.length > 0 && (
                            <Swiper {...swiperParams}>
                                {notify.map((item, index) => (
                                    item.title !== "marquee" && item.isShow === true ? (
                                        <SwiperSlide key={`banner-${index}`}>
                                            <img alt={item.title} src={item.image} style={{ width: "100%", display: "block" }} />
                                        </SwiperSlide>
                                    ) : null
                                ))}
                            </Swiper>
                        )}
                    </div>

                    {!profile && (
                        <div className="auth-action-bar">
                            <Link to="/login" className="btn-login-bar">ĐĂNG NHẬP</Link>
                            <Link to="/register" className="btn-register-bar">ĐĂNG KÝ</Link>
                        </div>
                    )}

                    {profile && (
                        <section className="logend">
                            <div className="logend-cont">
                                <span>Chào Mừng <em>{profile.username}</em></span>
                                <Link  className="mem_vip"></Link>
                                <Link to="/recharge/bank" className="fr-wallet">
                                    <span>Số Dư: {Math.floor((profile?.money || 0) / 1000).toLocaleString("vi-VN")}</span>
                                </Link>
                            </div>
                        </section>
                    )}

                  {activeTab === "HOME" ? (
    <div className="home-grid-container mt-2">
        {homeCategories.map((cat, idx) => (
            <div 
                className="home-game-card" 
                key={`cat-${idx}`} 
                onClick={() => {
                    // Kiểm tra nếu category có cấu hình link thì chuyển hướng luôn
                    if (cat.link) {
                        navigate(cat.link);
                    } else {
                        // Nếu không có link thì mới mở Tab sảnh con
                        setActiveTab(cat.id);
                    }
                }}
            >
                <img src={`https://dztwieyphe62d.cloudfront.net/content/images/sandsvn/home/${cat.img}?v=01`} alt={cat.title} />
                <span className="home-game-title">{cat.title}</span>
            </div>
        ))}
    </div>
) : (
                        <div>
                            <div className="subgame-header" onClick={() => setActiveTab("HOME")}>
                                <ArrowBackIosNewIcon sx={{ fontSize: "16px", marginRight: "5px" }} /> 
                                {homeCategories.find(c => c.id === activeTab)?.title}
                            </div>

                            {subGames[activeTab] ? (
                                <div className="subgame-grid-container">
                                    {subGames[activeTab].map((game, idx) => (
                                        <div className="subgame-card" key={`subgame-${idx}`} onClick={() => handleGameAction(game)}>
                                            <div className="subgame-img-wrap">
                                                <img src={game.imgUrl} alt={game.title} />
                                            </div>
                                            <div className="subgame-title">{game.title}</div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div style={{ textAlign: 'center', padding: '50px 20px', color: '#666', fontSize:'14px' }}>
                                    Đang cập nhật sảnh này.
                                </div>
                            )}
                        </div>
                    )}

                    <div className="footer-info-container">
                        <div className="home-footer-logo">
                            <img src="https://dztwieyphe62d.cloudfront.net/content/images/logo/logo-sandsvn.png" alt="Logo" />
                        </div>
                        <div className="footer-link-boxes">
                            <Link>Chi nhánh</Link>
                            <Link to="/notification">Khuyến mãi</Link>
                            <Link to="https://secure.livechatinc.com/licence/19707399/v2/open_chat.cgi" target="_blank">24/7 Customer Center</Link>
                        </div>
                    </div>
                </div>
            )}


            {/* THÔNG BÁO POPUP */}
            {profile && notify && (
                <>
                    {notify.map((item, index) => 
                        item.isShow && item.title === "popup" && !playGame ? (
                            <div className="global-popup-overlay" key={`system-popup-${index}`} onClick={(e) => { if(e.target === e.currentTarget) { /* Close logic */ } }}>
                                <div className="premium-popup" style={{ background: '#fff', borderRadius: '10px', maxWidth: '400px', width: '90%', position: 'relative', color: '#252323' }}>
                                    <div className="popup-close-top" onClick={() => {}} style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer', zIndex: 10 }}>
                                        <CloseIcon sx={{ color: '#333' }} />
                                    </div>
                                    <div style={{ padding: "30px 20px 20px" }}>
                                        {item.content.includes("{") && item.content.includes("}") ? (
                                            <img src={item.content.substring(item.content.indexOf("{") + 1, item.content.indexOf("}"))} style={{ width: "100%", height: "auto", borderRadius: '8px' }} alt="popup" />
                                        ) : (
                                            <div dangerouslySetInnerHTML={{ __html: item.content }} />
                                        )}
                                    </div>
                                </div>
                            </div>
                        ) : null
                    )}
                </>
            )}

            {/* POPUP CHỌN GAME CON (VÍ DỤ SLOT CQ9, JILI...) */}
            {showGameListPopup && gameList && (
                <div className="global-popup-overlay" onClick={(e) => { if(e.target === e.currentTarget) setShowGameListPopup(false); }}>
                    <div className="gamelist-popup">
                        <div className="gamelist-popup-header">
                            <span>{listTitle}</span>
                            <CloseIcon sx={{ cursor: 'pointer' }} onClick={() => setShowGameListPopup(false)} />
                        </div>
                        <div className="gamelist-popup-body">
                            <div className="gl-search-box">
                                <input type="text" placeholder="Tìm kiếm game..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                            </div>
                            <div className="new-grid-3">
                                {gameList.filter(item => item.gameName.toLowerCase().includes(searchQuery.toLowerCase())).map((item, index) => (
                                    <div className="new-gameslot-item" key={`game-${index}`} onClick={() => launchGame({ product_type: item.productType, game_code: item.tcgGameCode })}>
                                        <img src={`https://images.21947392.com/TCG_GAME_ICONS/${item.productCode}/VI/${item.tcgGameCode}.png`} onError={(e) => handleImageError(e, item.productCode, item.tcgGameCode)} alt={item.gameName} />
                                        <div className="new-gameslot-name">{item.gameName}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Chỉ render Footer khi KHÔNG có game nào đang chạy (Giúp iframe trồi lên) */}
            {!playGame && <Footer resetHome={() => setActiveTab("HOME")} />}
        </AnimatedPage>
    );
}

export default Home;